import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { OxResponse } from './response/OxResponse';
import { UserSettings } from '@app/typedef/define/user/UserSettings';
import { UserSettingsCodec } from '@app/typedef/codec/user/UserSettingsCodec';

/**
 * 当前用户的设置服务（目标 account 后端，基址 {@code environment.account}）。
 * 目前只有一项「组织是否启用」。身份由 JwtInterceptor 的 Bearer 令牌携带。
 */
@Injectable({ providedIn: 'root' })
export class UserSettingsService {
  private account: string = environment.account;

  constructor(private http: HttpClient) {}

  /** 读取当前用户设置（GET /user/settings）。 */
  getSettings(): Observable<UserSettings> {
    return this.http
      .get<OxResponse>(`${this.account}/user/settings`)
      .pipe(map((r) => UserSettingsCodec.decode(r.data)));
  }

  /** 更新当前用户设置（PUT /user/settings），body 只带组织开关一项。 */
  updateSettings(settings: UserSettings): Observable<void> {
    return this.http
      .put<OxResponse>(`${this.account}/user/settings`, {
        organizationEnabled: settings.organizationEnabled,
      })
      .pipe(map(() => undefined));
  }
}